import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box, ClickAwayListener, styled } from "@mui/material";
import clsx from "clsx";
import { useSidebarsContext } from "context/SidebarsProvider";
import InboxSidebarContainer from "../inbox/InboxSidebarContainer";
import SidebarContainer from "../../sidebars/SideBarContainer";

const SidebarWrapperStyled = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: theme.width.drawer,
  height: "100%",
  overflow: "hidden",
  zIndex: theme.zIndex.drawer,
  pointerEvents: "none",
}));

const SidebarContainerStyled = styled(SidebarContainer)({
  "& .inner": {
    overflow: "auto",
    padding: "1rem",
    pointerEvents: "auto",
  },
});

const DrawerBackgroundStyled = styled("div")(({ theme }) => ({
  zIndex: theme.zIndex.drawerBackground,
  opacity: 0,
  "&.open": {
    opacity: 1,
    position: "fixed",
    inset: 0,
    backgroundColor: "#00000088",
  },
}));

const GlobalSidebarsContainer = () => {
  const { selected, closeSidebar } = useSidebarsContext();

  const location = useLocation();

  useEffect(() => {
    if (typeof closeSidebar === "function") {
      closeSidebar();
    }
  }, [location.pathname, closeSidebar]);

  const isOpen = Boolean(selected);

  return (
    <>
      <ClickAwayListener onClickAway={closeSidebar}>
        <SidebarWrapperStyled>
          <SidebarContainerStyled isOpen={isOpen} size="lg">
            {selected === "inbox" && <InboxSidebarContainer />}
          </SidebarContainerStyled>
        </SidebarWrapperStyled>
      </ClickAwayListener>
      <DrawerBackgroundStyled className={clsx({ open: isOpen })} />
    </>
  );
};

export default GlobalSidebarsContainer;
